<app-action-bar-items [locationId]="'document-advance-payments-list'">
    <ng-template #preList>
        <div class="flex gap-1">
            <p-button
                icon="fa fa-plus"
                severity="primary"
                outlined="true"
                (onClick)="addNew()"
                [hidden]="
                    document().status === DocumentStatusType.CO ||
                    document().status === DocumentStatusType.RE
                "
                [disabled]="
                    loading() ||
                    this.editItem() != null ||
                    document().status === DocumentStatusType.CO ||
                    document().status === DocumentStatusType.RE
                "
            ></p-button>
            <p-button
                icon="fa fa-refresh"
                severity="primary"
                outlined="true"
                (onClick)="refreshItems()"
            ></p-button>
            <p-button
                icon="fa fa-trash"
                severity="primary"
                outlined="true"
                (onClick)="deleteItem(selectedItems())"
                [hidden]="
                    document().status === DocumentStatusType.CO ||
                    document().status === DocumentStatusType.RE
                "
                [disabled]="
                    selectedItems()?.length == 0 ||
                    loading() ||
                    this.editItem() != null ||
                    document().status === DocumentStatusType.CO ||
                    document().status === DocumentStatusType.RE
                "
            ></p-button>
            <!-- just left here if we need to show some p-message in future -->
            <!-- <p-messages #tradingSetInfoBar [severity]="'info'" class="ms-2">
                <ng-template pTemplate>
                    <div class="p-2 flex gap-4">
                        <span>
                            {{ 'trading-set.calc-price' | translate }} :
                            {{
                                tradingSetCalcPriceSig() | decimalPlacesCustom: this.decimalPlaces()
                            }}
                        </span>
                        |
                        <span>
                            {{ 'trading-set.last-purchase-price' | translate }} :
                            {{
                                tradingSetLastPurchasePriceSig()
                                    | decimalPlacesCustom: this.decimalPlaces()
                            }}
                        </span>
                        |
                        <span>
                            {{ 'trading-set.average-purchase-price' | translate }} :
                            {{
                                tradingSetAveragePurchasePriceSig()
                                    | decimalPlacesCustom: this.decimalPlaces()
                            }}
                        </span> 
                    </div>
                </ng-template>
            </p-messages> -->
        </div>
    </ng-template>
    <ng-template #postList>
        <div class="flex gap-1">
            <!-- toggle sidebar button -->
            <!-- for now hide this feature -->
            <!-- <p-button
            icon="fa fa-bars"
            label="{{ 'product.toggle-product-sidebar' | translate }}"
            (onClick)="toggleSidebar()"
        ></p-button> -->
        </div>
    </ng-template>
</app-action-bar-items>
<p-table
    #advancePaymentsTable
    [value]="items()"
    [scrollable]="true"
    selectionMode="multiple"
    editMode="row"
    [(selection)]="selectedItems"
    [loading]="loading()"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="w-full"
    class="w-full"
    dataKey="id"
>
    <ng-template pTemplate="header">
        <tr>
            <th>{{ 'common.identifier' | translate }}</th>
            <th class="!text-right">{{ 'common.total' | translate }}</th>
            <th class="!text-right">{{ 'common.taxPercentage' | translate }}</th>
            <th class="!text-right">{{ 'document.date' | translate }}</th>
            <th class="!text-right">{{ 'common.totalWithTax' | translate }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-editing="editing">
        <tr
            [pSelectableRow]="rowData"
            [pSelectableRowIndex]="rowIndex"
            [pEditableRow]="rowData"
            (dblclick)="onEditInit(rowData, rowIndex)"
        >
            <td>
                @if (rowData.referenceDocumentId) {
                    <a
                        class="text-primary hover:underline"
                        [routerLink]="getReferencedDocumentUrl(rowData.referenceDocumentId)"
                    >
                        {{ rowData.description }}
                    </a>
                } @else {
                    {{ rowData.description }}
                }
            </td>
            <td class="!text-right">
                {{ rowData.proratedLinePrice | decimalPlacesCustom: decimalPlaces() }}
            </td>
            <td class="!text-right">
                {{ rowData.taxPercentage | decimalPlacesCustom: decimalPlaces() }}%
            </td>
            <td class="!text-right">
                @if (rowData.referenceDocument?.date) {
                    {{ rowData.referenceDocument.date | localeDate: 'shortDate' }}
                }
            </td>
            <td class="!text-right">
                {{ rowData.proratedLinePriceWithTax | decimalPlacesCustom: decimalPlaces() }}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="'100%'" class="text-center p-4">
                <div class="text-gray-500 p-4 justify-self-center">
                    <p>{{ 'common.no-items' | translate }}</p>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
